import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'vault-setup-loading',
  templateUrl: './vault-setup-loading.component.html',
  styleUrl: './vault-setup-loading.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VaultSetupLoadingComponent {
  @Input() text = 'One moment while we check for existing items';

  questionContentAnimationOptions: AnimationOptions = {
    path: 'assets/images/lottie-img/question-content-animation.json',
  };

  constructor() {}

  ngOnInit(): void {}
}
